export function keynestLink(value) {
    const link = String(value || '').trim();
    if (!link || link.length > 2048 || !/^https:\/\//i.test(link) || /[\s\\]/.test(link)) return '';
    try {
        const url = new URL(link);
        return url.protocol === 'https:' && url.hostname && !url.username && !url.password ? link : '';
    } catch { return ''; }
}
